module.exports = __webpack_public_path__ + "img/bpRed.6f484a66.png";